<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg' }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">
                        Remove Provider
                    </h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <div>
                <p>Are you sure you want to remove this provider?</p>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" size="lg" color="white">
                        Cancel
                    </UButton>
                    <UButton @click="confirm()" size="lg" :loading="loading" color="red">
                        Remove
                    </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import type { Provider } from '~/types/provider'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [boolean]
}>()

const props = defineProps<{
    open: boolean
    provider?: Provider
}>()

const client = useSupabaseClient()
const toast = useToast()
const loading = ref<boolean>(false)

async function confirm() {
    if (props.provider) {
        loading.value = true

        const { data, error } = await client
            .from('providers')
            .update({ deleted_at: new Date() } as never)
            .eq('id', props.provider.id)
            .select()

        if (data) {
            dismiss(true)
        }
        else if (error) {
            toast.add({
                title: 'Could not delete provider, please try again later.',
                color: 'red',
                icon: 'i-ph-warning-duotone'
            })
        }

        loading.value = false
    }
}

function dismiss(reload: boolean = false) {
    emit('update:open', false)

    if (reload) {
        emit('reload', true)
    }
}
</script>
